import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
  }

  handleVisibilityChange() {
    if (document.visibilityState !== "visible") return
    if (this.hasDirtyForm()) return
    if (this.isAuthenticationModal()) return
    if (this.isPaymentMethodPage()) return

    window.scrollTo({ top: 0, left: 0, behavior: "instant" })

    Turbo.visit(window.location.toString(), { action: "replace" })
  }

  hasDirtyForm() {
    for (const form of document.forms) {
      for (const el of form.elements) {
        if (!("defaultValue" in el)) continue
        if (el.defaultValue !== el.value) return true
      }
    }
    return false
  }

  isAuthenticationModal() {
    return window.location.toString().includes("authentication_modal=true")
  }

  isPaymentMethodPage() {
    return window.location.toString().includes("payment_methods")
  }
}
